module.exports = __webpack_public_path__ + "files/a490e46b6488c64bc9f5d18822d44384.png";